@for (item of items; track item; let i = $index) {
  <span>
    <i [ngStyle]="{ background: item.color }"></i>
    {{ item.label }}
  </span>
}
